import { h, createRef } from 'preact';
import { PLAYER_EVENT, PLAYER_CONTROL_EVENT } from 'constants/events';
import { BaseAnnotation } from 'rendering/annotations/base_annotation';

export class AudioAnnotation extends BaseAnnotation {
    constructor(props) {
        super(props);
        this.el = createRef();
        this.state.playing = false;
        this.state.volume = 1;

        this.eventBus.on(PLAYER_EVENT.PLAY, this.onPlay);
        this.eventBus.on(PLAYER_EVENT.PAUSE, this.onPause);
        this.eventBus.on(PLAYER_EVENT.SEEKED, this.onSeeked);
        this.eventBus.on(PLAYER_EVENT.VOLUME_CHANGE, this.onVolumeChange);
    }

    onSeeked = (player, adapter) => {
        if (this.el?.current) {
            this.el.current.currentTime = adapter.currentTime;
        }
    }

    onPlay = (player, adapter) => {
        if (this.el?.current) {
            this.el.current.play();
            this.el.current.currentTime = adapter.currentTime;            
        }
        
        this.setState({
            playing: true
        })
    }

    onPause = (player, adapter) => {
        if (this.el?.current) {
            this.el.current.pause();            
        }

        this.setState({
            playing: false
        });
    }

    onVolumeChange = (player, adapter) => {
        this.setState({
            volume: adapter.volume
        });
    }

    componentWillUnmount() {
        this.eventBus.off(PLAYER_EVENT.SEEKED, this.onSeeked);
        this.eventBus.off(PLAYER_EVENT.PLAY, this.onPlay);
        this.eventBus.off(PLAYER_EVENT.PAUSE, this.onPause);
        this.eventBus.off(PLAYER_EVENT.VOLUME_CHANGE, this.onVolumeChange);
    }

    render() {
        const { volume } = this.state;

        if (this.contents) {
            // audio annotation should supersede any other audio? 
            this.eventBus.emit(PLAYER_CONTROL_EVENT.MUTE, true);
        }

        return (
            <audio volume={volume} src={this.contents} ref={this.el} />
        )
    }

    get contents() {
        return this.props.content;
    }
}